module.exports = __webpack_public_path__ + "img/max-file-content-add.4cf9f803.svg";